<template>
    <v-responsive fluid v-resize="myEventHandler">
        <div>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión de Adicionales
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión de Adicionales
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openAddingForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Nueva Adicional
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="additionalManagement.additionals"
                :loading="loadingItems"
                :page.sync="page"
                :footer-props="footerProps"
                :server-items-length="totalEntries"
                :options.sync="options"
                :search="search"
                class="px-2"
                hide-default-footer
            >
                <template v-slot:footer="{ props }">
                    <v-data-footer
                        style="height: 60px; justify-content: flex-end"
                        :items-per-page-options="props.itemsPerPageOptions"
                        :options.sync="options"
                        :pagination.sync="props.pagination"
                        show-first-last-page
                    >
                    </v-data-footer>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col v-if="hasSuperAdminPermission" md="2">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </div>
    </v-responsive>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'AditionalManagementTable',

    data: () => ({
        tableHeight: 300,
                footerProps: {
            itemsPerPageOptions: [0],
        },
        options: {},
        headers: [
            { text: 'Nombre', value: 'name', sortable: false },
            { text: 'Operador', value: 'operator', sortable: false },
            { text: 'Segmento', value: 'segment', sortable: false },
            { text: 'Precio', value: 'price', sortable: false },
            { text: 'Activa', value: 'is_active', sortable: false },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '200px',
            },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.additionalManagement.IsActive =
                item.is_active;
            this.$store.state.ManagementBase.additionalManagement.Name =
                item.name;
            this.$store.state.ManagementBase.additionalManagement.segment =
                item.segment;
            this.$store.state.ManagementBase.additionalManagement.Operator =
                item.operator;
            this.$store.state.ManagementBase.additionalManagement.Mobile_Line_Data =
                item.mobile_line_info?.mobile_line_data.amount;
            this.$store.state.ManagementBase.additionalManagement.Data_Unit =
                item.mobile_line_info?.mobile_line_data.unit;
            this.$store.state.ManagementBase.additionalManagement.Voice =
                item.mobile_line_info?.mobile_line_voice.amount;
            this.$store.state.ManagementBase.additionalManagement.Voice_Unit =
                item.mobile_line_info?.mobile_line_voice.unit;
            this.$store.state.ManagementBase.additionalManagement.Price =
                item.price;
            this.$store.state.ManagementBase.additionalManagement.MaxNumber =
                item.max_number;
            item.upfront
                ? (this.$store.state.ManagementBase.additionalManagement.Upfront =
                      item.upfront.upfront)
                : null;
            this.$store.state.ManagementBase.additionalManagement.editingId =
                item.id;
            this.$store.state.ManagementBase.additionalManagement.SelectedPromotions =
                item.promotions;
            this.$store.state.ManagementBase.additionalManagement.price_history =
                item.price_history;
            this.$store.state.ManagementBase.additionalManagement.upfront_history =
                item.upfront_history;
        },
        openAddingForm() {
            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADITIONAL';
            this.$store.state.ManagementBase.baseForm.formType = 'add';
            this.$store.state.ManagementBase.baseForm.isActive = true;
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/additionalManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADITIONAL';
            this.$store.state.ManagementBase.baseForm.formType = 'watch';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        editingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'ADITIONAL';
            this.$store.state.ManagementBase.baseForm.formType = 'edit';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
        ...mapActions('ManagementBase/additionalManagement', {
            getAdditionals: 'getAdditionals',
        }),
    },
    computed: {
        page: {
            get() {
                return this.$store.state.ManagementBase.additionalManagement
                    .additionalManagement.page;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/additionalManagement/additionalManagementPage',
                    val
                );
            },
        },
        ...mapState('ManagementBase/additionalManagement', {
            additionalManagement: (state) => state.additionalManagement,
            totalEntries: (state) => state.additionalManagement.totalEntries,
            isLoading: (state) => state.isLoading,
        }),
        ...mapState('ManagementBase', {
            itemsPerPage: (state) => state.itemsPerPage,
            managementFiltersForm: (state) => state.managementFilters.form,
            loadingItems: (state) => state.loadingItems,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    watch: {
        tableHeight() {
            this.footerProps.itemsPerPageOptions[0] = Math.floor(
                this.tableHeight / 48 - 1
            );
            this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
        },
        managementFiltersForm: {
            deep: true,
            immediate: true,
            handler(val) {
                this.options.page = 1;
                this.$store.dispatch(
                    'ManagementBase/additionalManagement/updateAdditionalManagementParams',
                    { ...this.managementFiltersForm, page: 1 }
                );

                this.getAdditionals();
            },
        },
        options: {
            immediate: false,
            handler() {
                let page = this.options.page;
                if (
                    this.additionalManagement.page != page &&
                    !this.additionalManagement.isLoading
                ) {
                    this.$store.dispatch(
                        'ManagementBase/additionalManagement/updateAdditionalManagementParams',
                        this.options
                    );
                    this.getAdditionals();
                }
            },
            // Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
            deep: true,
        },
        search() {
            // Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
            setTimeout(() => {
                if (!this.additionalManagement.isLoading) {
                    this.options.page = 1;
                    this.additionalManagement.page = 1;
                    
                    this.$store.dispatch(
                        'ManagementBase/additionalManagement/updateAdditionalManagementParams',
                        { search: this.search }
                    );
                    this.getAdditionals();
                }
            }, 300);
        },
    }
};
</script>

<style>
</style>